<template>
  <div class="Custom-tableContainer">
    <!-- Submenú en la parte superior del card -->
    <div>
      <SubMenu
        v-if="showHeader"
        :items="MenuOptions.contexts.samples.itemsByArea[showHeader]"
      />
    </div>
    <div id="report-container"></div>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client';
import { mapGetters, mapState } from 'vuex';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';

export default {
  components: { SubMenu },
  data() {
    return { MenuOptions };
  },
  computed: {
    ...mapGetters('contact', ['contactInfo']),
    ...mapState('contact', ['company']),
    ...mapState('PowerBiModules', [
      'insertionToken',
      'reportId',
      'showHeader',
    ]),
  },
  mounted() {
    if (this.insertionToken && this.reportId) {
      this.embedReport();
    }
  },
  methods: {
    async embedReport() {
      if (!this.insertionToken || !this.reportId) {
        console.error('Missing Token or Report ID.');
        return;
      }
      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      const embedContainer = document.getElementById(
        'report-container'
      );
      powerbi.reset(embedContainer);

      const config = this.getEmbedConfig();

      try {
        // importante: guardamos la instancia del reporte
        const report = powerbi.embed(embedContainer, config);

        // Evitamos duplicar handlers si se re-embebe
        report.off('loaded');
        report.off('rendered');
        report.off('error');

        // Cuando cargue, quitamos borde/sombra del iframe
        const applyFrameStyles = () => {
          const iframe = embedContainer.querySelector(
            'iframe, .powerbi-frame'
          );
          if (iframe) {
            iframe.style.border = 'none';
            iframe.style.outline = 'none';
            iframe.style.boxShadow = 'none';
            iframe.style.borderRadius = '0';
          }
        };

        report.on('loaded', applyFrameStyles);
        // Por si “loaded” se dispara muy pronto o al cambiar de página
        report.on('rendered', applyFrameStyles);

        report.on('error', (e) => {
          console.error('Power BI embed error:', e?.detail || e);
        });
      } catch (error) {
        console.error('Error embedding the report:', error);
      }
    },
    getEmbedConfig() {
      return {
        type: 'report',
        accessToken: this.insertionToken,
        embedUrl: 'https://app.powerbi.com/reportEmbed?',
        id: this.reportId,
        permissions: pbi.models.Permissions.Read,
        tokenType: pbi.models.TokenType.Embed,
        settings: {
          panes: {
            bookmarks: {
              visible: false,
            },
            fields: {
              expanded: false,
            },
            filters: {
              expanded: true,
              visible: true,
            },
            pageNavigation: {
              visible: true,
            },
            selection: {
              visible: true,
            },
            syncSlicers: {
              visible: true,
            },
            visualizations: {
              expanded: false,
            },
          },
          bars: {
            actionBar: {
              visible: false,
            },
            statusBar: {
              visible: true,
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '../PowerBIEmbedded/informecontainer.styles.scss';
</style>
